const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

export const API_ROOT = process.env.NODE_ENV === "production" || !configuredBackendUrl ? "" : configuredBackendUrl;
export const API = `${API_ROOT}/api`;

export function publicUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_ROOT}${path.startsWith("/") ? path : `/${path}`}`;
}
